<script>
  export default {
    name: "Tooltip",
    props: {
      text: {
        type: String,
        default: "",
      },
      variant: {
        type: String,
        default: "default",
      },
    },
  };
</script>
<template>
  <transition name="fade-tooltip">
    <div :class="`tooltipContainer tooltipContainer--${variant}`">
      {{ text }}
    </div>
  </transition>
</template>

<style lang="scss">
  .tooltipContainer {
    position: absolute;
    bottom: -33px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.6);
    color: white;
    font-family: $newFont_regular;
    font-size: 12px;
    padding: 4px 6px;
    border-radius: 6px;
    white-space: nowrap;
    font-weight: 500;
    text-transform: none;
    backdrop-filter: blur(5px);
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.28);
    z-index: 10;

    &--default {
      &::before {
        content: "";
        position: absolute;
        top: -4px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 4px solid rgba(0, 0, 0, 0.6);
      }
    }
    &--leftPosition {
      left: -4px;
      bottom: 0;
      transform: translateX(-100%);
      &::before {
        right: -4px;
        left: unset;
        top: 50%;
        transform: translateY(-50%);
        border: none;
        border-left: 4px solid rgba(0, 0, 0, 0.6);
        border-top: 4px solid transparent;
        border-bottom: 4px solid transparent;
      }
    }

    &--right {
      top: 50%;
      bottom: auto;
      left: calc(100% + 8px);
      transform: translateY(-50%);

      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: -4px;
        transform: translateY(-50%);
        border: none;
        border-right: 4px solid rgba(0, 0, 0, 0.6);
        border-top: 4px solid transparent;
        border-bottom: 4px solid transparent;
      }
    }

    &--down {
      bottom: auto;
      top: -30px;

      &::before {
        content: "";
        position: absolute;
        bottom: -4px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid rgba(0, 0, 0, 0.6);
      }
    }
    &--down_upper {
      bottom: auto;
      top: -33px;

      &::before {
        content: "";
        position: absolute;
        bottom: -4px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid rgba(0, 0, 0, 0.6);
      }
    }
  }
  .fade-tooltip-enter-active,
  .fade-tooltip-leave-active {
    transition: opacity 0.15s ease-in-out;
  }

  .fade-tooltip-enter-from,
  .fade-tooltip-leave-to {
    opacity: 0;
  }

  .fade-tooltip-enter-to,
  .fade-tooltip-leave-from {
    opacity: 1;
  }
</style>
